module.exports = __webpack_public_path__ + "img/allocated-icon.0bccc140.svg";